import { render } from "./BereidJeUitvaartVoorView.vue?vue&type=template&id=4c274e3b"
import script from "./BereidJeUitvaartVoorView.vue?vue&type=script&lang=js"
export * from "./BereidJeUitvaartVoorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__